import { render, staticRenderFns } from "./TariffComparision.vue?vue&type=template&id=a6f87bd6"
import script from "./TariffComparision.vue?vue&type=script&lang=js"
export * from "./TariffComparision.vue?vue&type=script&lang=js"
import style0 from "./TariffComparision.vue?vue&type=style&index=0&id=a6f87bd6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports